import { Modal } from 'stories/components'

import { PaymentImportWizard } from './PaymentImportWizard'

interface Props {
  loanNumber: number
  /** A file dropped on the payments panel. The wizard parses it as soon as the modal opens. */
  initialFile?: File | null
  onClose: () => void
  onImported: () => void
}

/** The same mapped importer, scoped to the loan it was opened from. */
export const PaymentImportModal = ({ loanNumber, initialFile, onClose, onImported }: Props) => {
  return (
    <Modal isOpen title={`Import Payments - Loan #${loanNumber}`} titleOkay="" onClose={onClose}>
      <div className="w-[1100px] max-w-full">
        <PaymentImportWizard loanNumber={loanNumber} initialFile={initialFile} onImported={onImported} />
      </div>
    </Modal>
  )
}
